import { render, staticRenderFns } from "./QuestionnaireView.vue?vue&type=template&id=2c147b42&"
import script from "./QuestionnaireView.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports